import {
  ContextObject as AxeContextObject,
  RunOptions as AxeRunOptions,
} from 'axe-core';
import { TJurisdictionLicenseConfig } from './license/license-types';

// global declaration for the rnw object
// It is used to initialize the Release Notes Widget. https://releasenotes.elevio.help/en/articles/87761-installing-the-popup-modal-or-banner
declare global {
  interface Window {
    rnw: (
      action: string,
      config?: {
        account?: string;
        selector?: string;
        // token for private releases https://releasenotes.elevio.help/en/articles/87789
        jwt?: string;
      }
    ) => void;
  }

  namespace Cypress {
    interface Chainable<Subject> {
      checkAccessibility(
        context?: string | Node | AxeContextObject,
        options?: AxeRunOptions
      ): Chainable<Subject>;
    }
  }
}

export type Nullable<T> = T | null | undefined;

export type TStatsPropertyDetails = {
  tabs: {
    activity: {
      enabled: boolean;
    };
    history: {
      enabled: boolean;
    };
    license: TJurisdictionLicenseConfig;
  };
};

export type TabConfig = any;

// Values matches with licenseEditMode types in customer config
export enum AdminUpdateConfigType {
  RentalscapeEditor = 'rs_on_page',
  RegistrationSystemEditor = 'reg',
  ExpressPortalEditor = 'xcp',
}

export type DashboardRouteParams = {
  propertyDeckardId?: string;
  region: string;
  tab: string;
  propertyDetailsTab?: string;
};

export type ComplaintsRouteParams = {
  complaintId?: string;
  region: string;
};

export type NavigationItems =
  | 'dashboard'
  | 'home'
  | 'cards'
  | 'list'
  | 'tax-reporting'
  | 'help'
  | 'complaints';

export type PropertyOverviewTabs =
  | 'overview'
  | 'license'
  | 'activity'
  | 'complaints'
  | 'history'
  | 'inspections'
  | 'propertyOverviewTaxTab'
  | 'violationsTab';

export type DashboardAvailableDataset =
  | 'CURRENT_STR_PROPERTIES'
  | 'OCCUPANCY'
  | 'AVG_DAILY_RATE'
  | 'REVENUE'
  | 'BOOKED'
  | 'TRANSIENT_OCCUPANCY_TAX'
  | 'REGISTRATION_RATE'
  | 'UNIT_TYPE'
  | 'RESIDENTIAL_TYPE'
  | 'ONLINE_PLATFORMS'
  | 'RENTAL_SIZE'
  | 'RENTAL_STRUCTURE'
  | 'MOST_ACTIVE_HOSTS'
  | 'MOST_ACTIVE_OWNERS'
  | 'TOP_ONLINE_PLATFORMS'
  | 'RENTAL_CATEGORIES'
  | 'STACKED_BOOKED_RATIO'
  | 'ESTIMATED_RENTAL_ACTIVITIES';
